import { render, staticRenderFns } from "./SearchNavItemFieldSelect.vue?vue&type=template&id=1b0232ab&scoped=true&"
import script from "./SearchNavItemFieldSelect.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemFieldSelect.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemFieldSelect.vue?vue&type=style&index=0&id=1b0232ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0232ab",
  null
  
)

export default component.exports